import { PATH_NAME, SCREEN_NAME } from "@/constants";
import { MenuDataTypes } from "./types";

export const MenuData: MenuDataTypes = [
  {
    id: SCREEN_NAME.DASHBOARD,
    label: SCREEN_NAME.DASHBOARD,
    icon: "ri-line-chart-line",
    link: PATH_NAME.DASHBOARD,
  },
  {
    id: SCREEN_NAME.USER_MANAGEMENT,
    label: SCREEN_NAME.USER_MANAGEMENT,
    icon: "ri-user-3-line",
    link: PATH_NAME.USER_MANAGEMENT,
  },
  {
    id: SCREEN_NAME.ENTERPRISE_MANAGEMENT,
    label: SCREEN_NAME.ENTERPRISE_MANAGEMENT,
    icon: "ri-group-line",
    link: PATH_NAME.ENTERPRISE_MANAGEMENT,
  },
  {
    id: SCREEN_NAME.SUBSCRIPTION_MANAGEMENT,
    label: SCREEN_NAME.SUBSCRIPTION_MANAGEMENT,
    icon: "ri-pages-line",
    link: PATH_NAME.SUBSCRIPTION_MANAGEMENT,
  },
  {
    id: SCREEN_NAME.POS_MANAGEMENT,
    label: SCREEN_NAME.POS_MANAGEMENT,
    icon: "ri-function-line",
    link: PATH_NAME.POS_MANAGEMENT,
  },
  {
    id: SCREEN_NAME.REDEMPTION_MANAGEMENT,
    label: SCREEN_NAME.REDEMPTION_MANAGEMENT,
    icon: "ri-settings-4-line",
    link: PATH_NAME.REDEMPTION_MANAGEMENT,
  },
  {
    id: SCREEN_NAME.CAMPAIGN_MANAGEMENT,
    label: SCREEN_NAME.CAMPAIGN_MANAGEMENT,
    icon: "ri-megaphone-line",
    link: PATH_NAME.CAMPAIGN_MANAGEMENT,
  },
];
